export default __webpack_public_path__ + "static/media/931.f2f97301.png";